<template>
  <section id="product" class="ai-product-section">
    <div class="container">
      <div class="hover-tabs" :class="{ 'mobile-view': isMobile }">
        <!-- 标签头部 -->
        <div class="tabs-header">
          <div v-for="(tab, index) in tabs" :key="index" class="tab-header" :class="{ active: activeTab === index }"
            @mouseenter="!isMobile && (activeTab = index)" @click="isMobile && (activeTab = index)">
            <div></div>= {{ tab.title }}
          </div>
        </div>

        <!-- 标签内容 -->
        <div class="tabs-content">
          <el-carousel :interval="3000" style="" arrow="always">
            <el-carousel-item v-for="item in tabs[activeTab].tabs" :key="item">
              <transition name="fade" mode="out-in">
                <div :key="activeTab" class="tab-content">
                  <div class="product-grid">
                    <!-- 产品主展示区 -->
                    <div class="product-showcase">
                      <div class="product-image">
                        <img  :src="item.image" alt="" class="main-device" loading="lazy">
                        <div class="device-overlay">
                          <!-- <div class="overlay-text">{{ item.title + item.sp }}</div> -->
                        </div>
                      </div>
                    </div>

                    <!-- 产品功能描述 -->
                    <div class="product-details">
                      <div class="core-feature">
                        <div class="feature-icon">
                          <svg viewBox="0 0 24 24">
                            <path
                              d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z" />
                          </svg>
                        </div>
                        <div class="feature-text">
                          <h3>{{ item.title + item.sp}}</h3>
                          <p>{{ item.content }}</p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </transition>
            </el-carousel-item>
          </el-carousel>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { ElCarousel, ElCarouselItem } from 'element-plus'
const tabs = ref([
  {
    title: 'AI策划智能一体机', stitle: '一键解锁高效会议,用AI重塑会议生产力', sp: 'SP100', image: require('@/assets/images/SP100.jpg'), content: '一键解锁高效会议！精准声纹识别，智能提炼每位发言人的核心观点、优缺点及创新建议；自动整合全场讨论，生成会议共识、改进方向和爆点灵感；3秒输出结构化方案、PPT及会议纪要。用AI重塑会议生产力，让沟通价值清晰可见。方案、PPT及会议纪要。用AI重塑会议生产力，让沟通价值清晰可见',
    tabs: [
      { title: 'AI策划智能一体机', stitle: '一键解锁高效会议,用AI重塑会议生产力', sp: 'SP100', image: require('@/assets/images/SP100.jpg'), content: '一键解锁高效会议！精准声纹识别，智能提炼每位发言人的核心观点、优缺点及创新建议；自动整合全场讨论，生成会议共识、改进方向和爆点灵感；3秒输出结构化方案、PPT及会议纪要。用AI重塑会议生产力，让沟通价值清晰可见。方案、PPT及会议纪要。用AI重塑会议生产力，让沟通价值清晰可见', },
      { title: 'AI策划智能一体机', stitle: '一键解锁高效会议,用AI重塑会议生产力', sp: 'V7000', image: require('@/assets/images/V700.jpg'), content: '一键解锁高效会议！精准声纹识别，智能提炼每位发言人的核心观点、优缺点及创新建议；自动整合全场讨论，生成会议共识、改进方向和爆点灵感；3秒输出结构化方案、PPT及会议纪要。用AI重塑会议生产力，让沟通价值清晰可见' },
    ]
  },

  {
    title: 'AI策划助理', stitle: '你的全能创意助理,AI智能生成方案', sp: 'SP200', image: require('@/assets/images/SP200.jpg'), content: '你的全能创意助理，通过智能问答精准分析需求，快速梳理策划方案；实时解答各类疑问，提供专业建议；AI智能生成方案，支持移动端保存，随时查阅。高效、智能、便捷，助你轻松搞定策划难题', tabs: [
      { title: 'AI策划助理', stitle: '你的全能创意助理,AI智能生成方案', sp: 'SP200', image: require('@/assets/images/SP200.jpg'), content: '你的全能创意助理，通过智能问答精准分析需求，快速梳理策划方案；实时解答各类疑问，提供专业建议；AI智能生成方案，支持移动端保存，随时查阅。高效、智能、便捷，助你轻松搞定策划难题' },
    ]
  },
]);

const activeTab = ref(0);
const isMobile = ref(false);

const checkScreenSize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
  checkScreenSize();
  window.addEventListener('resize', checkScreenSize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkScreenSize);
});
</script>

<style scoped>
.hover-tabs {
  border-radius: 4px;
  overflow: hidden;
  font-weight: 600;
}

.tabs-header {
  display: flex;
}

.tab-header {
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #555;
  flex: 1;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 1.5rem;
  background-color: #fff;
}

.tab-header:hover:not(.active) {
  background-color: #fff;
}

.tab-header.active {
  color: #fff;
  background-color: var(--primary);
}

.tabs-content {
  padding: 24px;
  min-height: 200px;
}

/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 响应式设计 - 移动端样式 */
@media (max-width: 768px) {
  .hover-tabs.mobile-view .tabs-header {
    flex-direction: column;
  }

  .hover-tabs.mobile-view .tab-header {
    text-align: left;
  }

  .tabs-content {
    padding: 16px;
    min-height: 150px;
  }
}

/* 小屏幕手机优化 */
@media (max-width: 480px) {
  .tab-header {
    padding: 10px 16px;
    font-size: 14px;
  }
}

.ai-product-section {
  /* padding: 100px 0; */
  background: #F4F4F4;
  position: relative;
  overflow: hidden;
  padding-bottom: 100px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 2.8rem;
  color: #1a365d;
  margin-bottom: 15px;
  font-weight: 700;
}

.section-header p {
  font-size: 1.3rem;
  color: #4a5568;
  max-width: 800px;
  margin: 0 auto;
}

.product-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  margin-top: 30px;
}

.product-showcase {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-image {
  position: relative;
  width: 250px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(67, 97, 238, 0.2);
}

.main-device {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.5s ease;
}

.device-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  text-align: center;
}

.overlay-text {
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.product-model {
  margin-top: 20px;
}

.model-badge {
  display: inline-block;
  background-color: var(--primary);
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 8px 20px;
  border-radius: 30px;
}

.product-details {
  /* padding: 18px; */
}

.core-feature {
  display: flex;
  margin-bottom: 35px;
  align-items: flex-start;
}

.feature-icon {
  width: 60px;
  height: 60px;
  background-color: rgba(67, 97, 238, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.feature-icon svg {
  width: 30px;
  height: 30px;
  fill: var(--primary);
}

.feature-text h3 {
  font-size: 1.5rem;
  color: #1a365d;
  margin-bottom: 10px;
}

.feature-text p {
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.6;
}

.value-proposition {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 40px 0;
}

.value-card {
  background: white;
  border-radius: 15px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(67, 97, 238, 0.15);
}

.value-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--primary);
  margin-bottom: 5px;
  line-height: 1;
}

.value-label {
  font-size: 1rem;
  color: #4a5568;
  font-weight: 600;
}

.product-cta {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}


/* 响应式设计 */
@media (max-width: 992px) {
  .product-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .product-image {
    max-width: 250px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .ai-product-section {
    /* padding: 80px 0; */
  }

  .section-header h2 {
    font-size: 2.2rem;
  }

  .product-cta {
    flex-direction: column;
  }

  .value-proposition {
    grid-template-columns: 1fr;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }


}

@media (max-width: 576px) {
  .section-header h2 {
    font-size: 1.8rem;
  }

  .core-feature {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .feature-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>